/** @type {!Object<string, ?Module>} */
let _activeTarget = null;

const state = {};

/**
 * Set the active target
 * @param {Module} target
 */
state.setActiveTarget = function(target) {
  _activeTarget = target;
};

/**
 * Get the active target
 * @return {Module} the active target
 */
state.getActiveTarget = function() {
  return _activeTarget;
};

export default state;
